import { saveLastActiveAppScreens } from '@/core/config.ts';
import { getReadingPlanLastPoint } from '@/modules/reading-plan/composables/useTrackReadingPlanPoint';
import { AppScreens } from '@/shared/types';
import type { RouteLocationRaw } from 'vue-router';

/**
 * Cold-start Location for `/`.
 */
export const getRedirectLocation = (): RouteLocationRaw => {
  const lastActiveAppSection = localStorage.getItem('last-active-app-screen');

  if (!lastActiveAppSection || !saveLastActiveAppScreens.includes(lastActiveAppSection as AppScreens)) {
    return { name: AppScreens.Stories };
  }

  // temp redirect to interactive
  if (lastActiveAppSection === AppScreens.InteractiveBible) {
    return { name: AppScreens.Stories };
  }

  if (lastActiveAppSection === AppScreens.ReadingPlanDay) {
    const lastPoint = getReadingPlanLastPoint();

    if (
      !lastPoint?.readingPlanId
      || !Number.isFinite(lastPoint.dayNumber)
      || Number.isNaN(lastPoint.dayNumber)
    ) {
      return { name: AppScreens.ReadingPlans };
    }

    return {
      name: AppScreens.ReadingPlanDay,
      params: {
        id: lastPoint.readingPlanId,
        dayIndex: String(lastPoint.dayNumber),
      },
      query: {
        slide: String(lastPoint.slideIndex ?? 0),
      },
    };
  }

  if (lastActiveAppSection === AppScreens.ReadingPlanDetail) {
    const lastPoint = getReadingPlanLastPoint();

    if (!lastPoint?.readingPlanId) {
      return { name: AppScreens.ReadingPlans };
    }

    return {
      name: AppScreens.ReadingPlanDetail,
      params: { id: lastPoint.readingPlanId },
    };
  }

  return { name: lastActiveAppSection as AppScreens };
};

/** Name of the section for analytics / UI. */
export const getLastActiveAppSection = (): AppScreens => {
  const location = getRedirectLocation();

  if (typeof location === 'object' && location !== null && 'name' in location && location.name) {
    return location.name as AppScreens;
  }

  return AppScreens.Stories;
};
